var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 616 358",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02F5EBFA-36E7-44EA-954C-5441852A3C6E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.2404895%",
    y1: "-27.7925985%",
    x2: "51.2404895%",
    y2: "112.241709%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#140D40",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4861FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDAE3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.81509758,16.1076214 L5.84357533,15.9936161 L6.69167838,14.4439231 L13.7129274,14.4439231 C14.4198283,14.4439231 15.0418891,14.0543305 15.3622639,13.4648547 L19,6.80078568 L17.3601561,5.88814546 L17.3506635,5.88814546 L16.314192,7.78942938 L13.7129274,12.5426392 L7.09689305,12.5426392 L6.97437939,12.285903 L4.8631694,7.78942938 L3.96790008,5.88814546 L3.08212334,3.98686154 L0,3.98686154 L0,5.88814546 L1.88516784,5.88814546 L5.27787666,13.1036885 L4.00557377,15.4325668 C3.854879,15.6988782 3.76974239,16.0124674 3.76974239,16.345207 C3.76974239,17.391003 4.61814208,18.246491 5.65491023,18.246491 L16.9641374,18.246491 L16.9641374,16.345207 L6.05063232,16.345207 C5.9284153,16.345207 5.81509758,16.2407771 5.81509758,16.1076214 M15.0792662,19.1971329 C14.042498,19.1971329 13.2038876,20.0529202 13.2038876,21.0984168 C13.2038876,22.1442128 14.042498,23 15.0792662,23 C16.1160343,23 16.9641374,22.1442128 16.9641374,21.0984168 C16.9641374,20.0529202 16.116331,19.1971329 15.0792662,19.1971329 M5.65491023,19.1971329 C4.61814208,19.1971329 3.77953162,20.0529202 3.77953162,21.0984168 C3.77953162,22.1442128 4.61814208,23 5.65491023,23 C6.69167838,23 7.53978142,22.1442128 7.53978142,21.0984168 C7.53978142,20.0529202 6.69167838,19.1971329 5.65491023,19.1971329 M16.5174002,0 L17.9542613,1.4490076 L9.76125785,9.71262237 L5.64828833,5.56383871 L7.08514938,4.11483111 L9.76125785,6.81424209 L16.5174002,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45454545,12.2692308 L0,12.2692308 C0,10.3319838 0,8.39473684 0.21,6.34771255 C0.381818182,4.71396761 0.687272727,3.00919028 1.01818182,1.29149798 L0.636363636,1.29149798 L0.636363636,0 L1.27272727,0 L3.18181818,0 L3.81818182,0 L3.81818182,1.29149798 L3.43636364,1.29149798 C3.76727273,3.00919028 4.07272727,4.71396761 4.24454545,6.34771255 C4.45454545,8.39473684 4.45454545,10.3319838 4.45454545,12.2692308 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.77851355,14.3981637 C11.467234,11.1155615 12.8115942,8.44791962 12.8115942,6.3952381 C12.8115942,2.5394361 9.94362115,0 6.4057971,0 C2.86797305,0 0,2.5394361 0,6.3952381 C0,8.45436611 1.3875051,11.1323231 4.16251529,14.4291091 L4.16252026,14.4291049 C5.22948012,15.6966817 7.12199595,15.8593138 8.38957268,14.7923539 C8.53109558,14.6732296 8.66129709,14.5412708 8.77851355,14.3981637 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-10",
    cx: 2.390625,
    cy: 2.390625,
    r: 2.390625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77851355,14.3981637 C11.467234,11.1155615 12.8115942,8.44791962 12.8115942,6.3952381 C12.8115942,2.5394361 9.94362115,0 6.4057971,0 C2.86797305,0 0,2.5394361 0,6.3952381 C0,8.45436611 1.3875051,11.1323231 4.16251529,14.4291091 L4.16252026,14.4291049 C5.22948012,15.6966817 7.12199595,15.8593138 8.38957268,14.7923539 C8.53109558,14.6732296 8.66129709,14.5412708 8.77851355,14.3981637 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-14",
    cx: 2.390625,
    cy: 2.390625,
    r: 2.390625
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.346875,10.0774648 L0,10.0774648 C0,8.48628614 0,6.89510749 0.204924107,5.21376205 C0.372589286,3.87186805 0.670660714,2.47163084 0.993571429,1.06078577 L0.620982143,1.06078577 L0.620982143,0 L1.24196429,0 L3.10491071,0 L3.72589286,0 L3.72589286,1.06078577 L3.35330357,1.06078577 C3.67621429,2.47163084 3.97428571,3.87186805 4.14195089,5.21376205 C4.346875,6.89510749 4.346875,8.48628614 4.346875,10.0774648 Z",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39974457,12.5442478 L0,12.5442478 C0,10.5635771 0,8.58290638 0.20741653,6.48999767 C0.377120963,4.81963204 0.678817734,3.07664183 1.0056559,1.32044714 L0.628534939,1.32044714 L0.628534939,0 L1.25706988,0 L3.14267469,0 L3.77120963,0 L3.77120963,1.32044714 L3.39408867,1.32044714 C3.72092684,3.07664183 4.02262361,4.81963204 4.19232804,6.48999767 C4.39974457,8.58290638 4.39974457,10.5635771 4.39974457,12.5442478 Z",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39974457,12.5442478 L0,12.5442478 C0,10.5635771 0,8.58290638 0.20741653,6.48999767 C0.377120963,4.81963204 0.678817734,3.07664183 1.0056559,1.32044714 L0.628534939,1.32044714 L0.628534939,0 L1.25706988,0 L3.14267469,0 L3.77120963,0 L3.77120963,1.32044714 L3.39408867,1.32044714 C3.72092684,3.07664183 4.02262361,4.81963204 4.19232804,6.48999767 C4.39974457,8.58290638 4.39974457,10.5635771 4.39974457,12.5442478 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39974457,12.5442478 L0,12.5442478 C0,10.5635771 0,8.58290638 0.20741653,6.48999767 C0.377120963,4.81963204 0.678817734,3.07664183 1.0056559,1.32044714 L0.628534939,1.32044714 L0.628534939,0 L1.25706988,0 L3.14267469,0 L3.77120963,0 L3.77120963,1.32044714 L3.39408867,1.32044714 C3.72092684,3.07664183 4.02262361,4.81963204 4.19232804,6.48999767 C4.39974457,8.58290638 4.39974457,10.5635771 4.39974457,12.5442478 Z",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39974457,12.5442478 L0,12.5442478 C0,10.5635771 0,8.58290638 0.20741653,6.48999767 C0.377120963,4.81963204 0.678817734,3.07664183 1.0056559,1.32044714 L0.628534939,1.32044714 L0.628534939,0 L1.25706988,0 L3.14267469,0 L3.77120963,0 L3.77120963,1.32044714 L3.39408867,1.32044714 C3.72092684,3.07664183 4.02262361,4.81963204 4.19232804,6.48999767 C4.39974457,8.58290638 4.39974457,10.5635771 4.39974457,12.5442478 Z",
    id: "path-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDAE3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2278481,36 C30.8306962,36 36,29.25 36,17.4375 C36,5.625 30.9375,0 18,0 C5.0625,0 0,5.625 0,18 C0,30.375 5.625,36 18.2278481,36 Z",
    id: "path-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4032941,21.5051003 C15.859069,16.3271388 18.0869565,12.1682959 18.0869565,9.02857143 C18.0869565,3.58508626 14.0380534,0 9.04347826,0 C4.04890313,0 0,3.58508626 0,9.02857143 C0,12.1742862 2.29374035,16.343012 6.88122106,21.5347489 L6.88122005,21.5347498 C7.9783098,22.7763465 9.87418981,22.8934926 11.1157866,21.7964029 C11.2181421,21.7059603 11.3142015,21.608633 11.4032941,21.5051003 Z",
    id: "path-52"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-54",
    cx: 3.375,
    cy: 3.375,
    r: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4032941,21.5051003 C15.859069,16.3271388 18.0869565,12.1682959 18.0869565,9.02857143 C18.0869565,3.58508626 14.0380534,0 9.04347826,0 C4.04890313,0 0,3.58508626 0,9.02857143 C0,12.1742862 2.29374035,16.343012 6.88122106,21.5347489 L6.88122005,21.5347498 C7.9783098,22.7763465 9.87418981,22.8934926 11.1157866,21.7964029 C11.2181421,21.7059603 11.3142015,21.608633 11.4032941,21.5051003 Z",
    id: "path-56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-58",
    cx: 3.375,
    cy: 3.375,
    r: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4032941,21.5051003 C15.859069,16.3271388 18.0869565,12.1682959 18.0869565,9.02857143 C18.0869565,3.58508626 14.0380534,0 9.04347826,0 C4.04890313,0 0,3.58508626 0,9.02857143 C0,12.1742862 2.29374035,16.343012 6.88122106,21.5347489 L6.88122005,21.5347498 C7.9783098,22.7763465 9.87418981,22.8934926 11.1157866,21.7964029 C11.2181421,21.7059603 11.3142015,21.608633 11.4032941,21.5051003 Z",
    id: "path-60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-62",
    cx: 3.375,
    cy: 3.375,
    r: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7721519,43 C36.8255538,43 43,34.9375 43,20.828125 C43,6.71875 36.953125,0 21.5,0 C6.046875,0 0,6.71875 0,21.5 C0,36.28125 6.71875,43 21.7721519,43 Z",
    id: "path-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.952381,5.54761905 L14.3333333,5.54761905 C14.3333333,3.31333333 12.52,1.5 10.2857143,1.5 C8.05142857,1.5 6.23809524,3.31333333 6.23809524,5.54761905 L4.61904762,5.54761905 C3.72857143,5.54761905 3.00809524,6.27619048 3.00809524,7.16666667 L3,16.8809524 C3,17.7714286 3.72857143,18.5 4.61904762,18.5 L15.952381,18.5 C16.8428571,18.5 17.5714286,17.7714286 17.5714286,16.8809524 L17.5714286,7.16666667 C17.5714286,6.27619048 16.8428571,5.54761905 15.952381,5.54761905 L15.952381,5.54761905 Z M10.2857143,3.11904762 C11.6295238,3.11904762 12.7142857,4.20380952 12.7142857,5.54761905 L7.85714286,5.54761905 C7.85714286,4.20380952 8.94190476,3.11904762 10.2857143,3.11904762 L10.2857143,3.11904762 Z M10.2857143,11.2142857 C8.05142857,11.2142857 6.23809524,9.40095238 6.23809524,7.16666667 L7.85714286,7.16666667 C7.85714286,8.51047619 8.94190476,9.5952381 10.2857143,9.5952381 C11.6295238,9.5952381 12.7142857,8.51047619 12.7142857,7.16666667 L14.3333333,7.16666667 C14.3333333,9.40095238 12.52,11.2142857 10.2857143,11.2142857 L10.2857143,11.2142857 Z",
    id: "path-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2151899,33.5 C29.1178797,33.5 34,27.125 34,15.96875 C34,4.8125 29.21875,-0.5 17,-0.5 C4.78125,-0.5 0,4.8125 0,16.5 C0,28.1875 5.3125,33.5 17.2151899,33.5 Z",
    id: "path-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1248391,5.60759331 L14.4882883,5.60759331 C14.4882883,3.34915315 12.6553514,1.51621622 10.3969112,1.51621622 C8.13847104,1.51621622 6.30553411,3.34915315 6.30553411,5.60759331 L4.66898327,5.60759331 C3.76888031,5.60759331 3.04061519,6.34404118 3.04061519,7.24414414 L3.03243243,17.0634492 C3.03243243,17.9635521 3.76888031,18.7 4.66898327,18.7 L16.1248391,18.7 C17.0249421,18.7 17.76139,17.9635521 17.76139,17.0634492 L17.76139,7.24414414 C17.76139,6.34404118 17.0249421,5.60759331 16.1248391,5.60759331 L16.1248391,5.60759331 Z M10.3969112,3.15276705 C11.7552484,3.15276705 12.8517375,4.24925611 12.8517375,5.60759331 L7.94208494,5.60759331 C7.94208494,4.24925611 9.038574,3.15276705 10.3969112,3.15276705 L10.3969112,3.15276705 Z M10.3969112,11.3355212 C8.13847104,11.3355212 6.30553411,9.5025843 6.30553411,7.24414414 L7.94208494,7.24414414 C7.94208494,8.60248134 9.038574,9.6989704 10.3969112,9.6989704 C11.7552484,9.6989704 12.8517375,8.60248134 12.8517375,7.24414414 L14.4882883,7.24414414 C14.4882883,9.5025843 12.6553514,11.3355212 10.3969112,11.3355212 L10.3969112,11.3355212 Z",
    id: "path-70"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login-+-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home/welcome",
    transform: "translate(-483.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(483.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RUUDUKKO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.911957,12.0633945 C235.177999,16.8295971 342.678006,19.2126984 411.411978,19.2126984 C449.44695,19.2126984 484.514257,17.8343081 516.613901,15.0775274 L516.613901,15.0775276 C561.735155,11.2024254 601.45455,44.6390382 605.329653,89.7602925 C605.656381,93.5646786 605.716979,97.3872403 605.511006,101.200071 C604.305241,123.520293 603.702359,146.671592 603.702359,170.653968 C603.702359,203.49225 604.318908,236.122773 605.552005,268.54554 C607.273123,313.800173 571.982235,351.881542 526.727602,353.602659 C524.962718,353.669781 523.196125,353.679866 521.430589,353.632898 L313.030853,348.088889 L313.030853,348.088889 L87.6770243,353.784172 C42.4041305,354.928336 4.77566983,319.154933 3.631505,273.88204 C3.58508832,272.045401 3.6004101,270.207721 3.67744438,268.372111 L7.82577132,169.52381 L7.82577132,169.52381 L4.33865669,98.013796 C2.13288557,52.7801959 37.0138325,14.3229868 82.2474326,12.1172153 C84.4672934,12.008966 86.6906374,11.9910109 88.911957,12.0633945 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    opacity: 0.0796196057
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28760643,
    y1: 243.5,
    x2: 608.712394,
    y2: 243.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28760643,
    y1: 304.5,
    x2: 608.712394,
    y2: 304.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28760643,
    y1: 182.5,
    x2: 608.712394,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28760643,
    y1: 121.5,
    x2: 608.712394,
    y2: 121.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28760643,
    y1: 60.5,
    x2: 608.712394,
    y2: 60.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.079639,
    y1: 182.5,
    x2: 734.079639,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(560.579639, 182.500000) rotate(-270.000000) translate(-560.579639, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.180624,
    y1: 183.499996,
    x2: 672.180624,
    y2: 183.500004,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(499.180624, 183.500000) rotate(-270.000000) translate(-499.180624, -183.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.5755337,
    y1: 182.5,
    x2: 432.575534,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(259.075534, 182.500000) rotate(-270.000000) translate(-259.075534, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.6748768,
    y1: 183.5,
    x2: 372.674877,
    y2: 183.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(198.674877, 183.500000) rotate(-270.000000) translate(-198.674877, -183.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.477011,
    y1: 182.5,
    x2: 492.477011,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(318.977011, 182.500000) rotate(-270.000000) translate(-318.977011, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.376847,
    y1: 182.5,
    x2: 553.376847,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(379.876847, 182.500000) rotate(-270.000000) translate(-379.876847, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.278325,
    y1: 182.5,
    x2: 613.278325,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(439.778325, 182.500000) rotate(-270.000000) translate(-439.778325, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -142.027915,
    y1: 182.5,
    x2: 177.972085,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(17.972085, 182.500000) rotate(-270.000000) translate(-17.972085, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -95.1272578,
    y1: 182.5,
    x2: 251.872742,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(78.372742, 182.500000) rotate(-270.000000) translate(-78.372742, -182.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35.22578,
    y1: 182.5,
    x2: 311.77422,
    y2: 182.5,
    id: "Line-5",
    stroke: "#140D40",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    transform: "translate(138.274220, 182.500000) rotate(-270.000000) translate(-138.274220, -182.500000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337,56 L516.673139,56.0519905 C527.709188,56.0551839 536.656906,64.9970306 536.667343,76.0330753 L536.716734,128.25957 C536.746086,139.305242 527.800253,148.268011 516.754563,148.278457 C516.748258,148.278463 516.741953,148.278466 516.735649,148.259561 L395.415545,148.259561 C384.383539,148.259561 375.434915,157.192511 375.415575,168.2245 L375.3985,177.964939 C375.379137,189.010617 384.317731,197.980606 395.363409,197.999969 C395.375096,197.99999 395.386782,198 395.398469,198 L609,198 L609,198",
    id: "Path-3",
    stroke: "#140D40",
    opacity: 0.32,
    strokeDasharray: "6,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,56 L241.525988,56.1057351 C251.111645,56.1117492 258.879166,63.8841459 258.879166,73.469804 C258.879166,83.0537015 251.109882,90.8229855 241.525985,90.8229855 L188.41755,90.8229855 C177.610176,90.8229855 168.849069,99.5840929 168.849069,110.391467 C168.849069,121.199594 177.609422,129.962034 188.417549,129.964609 L337,130 L337,130",
    id: "Path-3",
    stroke: "#140D40",
    opacity: 0.32,
    strokeLinecap: "round",
    strokeDasharray: "6,3",
    transform: "translate(205.000000, 93.000000) scale(1, -1) translate(-205.000000, -93.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,12 L288.524205,12 C299.5699,12 308.524205,20.954305 308.524205,32 C308.524205,32.0336024 308.52412,32.0672048 308.523951,32.1008068 L308.355202,65.5800271 C308.299726,76.5862351 299.361804,85.4792203 288.355456,85.4792203 L237.630655,85.4792203 C226.819628,85.4792203 218.05556,94.2432887 218.05556,105.054315 C218.05556,115.885738 226.799049,124.685899 237.630246,124.755876 L292.726446,125.111837 C303.6827,125.182622 312.542478,134.055573 312.596987,145.011919 L313.017199,229.475071 C313.072151,240.520629 322.070894,249.430275 333.116452,249.375323 C333.179649,249.375008 333.242844,249.374394 333.306035,249.373481 L376.533413,248.748599 C387.577955,248.588942 396.660751,257.412885 396.820408,268.457426 C396.82264,268.611836 396.823084,268.766268 396.821739,268.920689 L396.324619,326 L396.324619,326",
    id: "Path-3",
    stroke: "#140D40",
    opacity: 0.32,
    strokeDasharray: "6,3",
    transform: "translate(273.000000, 169.000000) scale(1, -1) translate(-273.000000, -169.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,95 L99.319953,95 C105.923881,95 111.427307,100.058102 111.983224,106.63859 L112.753483,115.756275 C112.895397,117.436131 112.966448,119.121223 112.966448,120.807063 L112.966448,188.040258 C112.966448,199.721141 103.497221,209.190368 91.8163379,209.190368 C86.3207451,209.190368 81.0409387,207.051294 77.0950722,203.226156 C69.0372329,195.414857 68.8373726,182.550378 76.6486717,174.492539 C80.4625974,170.558238 85.7037884,168.330982 91.1832526,168.316036 L313,167.710978 L313,167.710978",
    id: "Path-3",
    stroke: "#140D40",
    opacity: 0.32,
    strokeDasharray: "6,3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(408.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(46.382576, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50.6174242,
    height: 102.693462,
    rx: 8
  })), /*#__PURE__*/React.createElement("line", {
    x1: 46.8085288,
    y1: 11.536101,
    x2: 96.0061095,
    y2: 11.536101,
    id: "Line",
    stroke: "#FCDAE3",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,7 L2.10261823,111.071282 C1.45248338,112.595254 2.16086836,114.357716 3.68484037,115.007851 C4.19397181,115.225049 4.7532685,115.297154 5.30083972,115.216187 L90.8181818,102.571096 L90.8181818,102.571096 L55.5788924,102.880009 C50.6085207,102.92358 46.5439169,98.9296189 46.5003458,93.9592471 C46.5001153,93.9329503 46.5,93.9066526 46.5,93.8803547 L46.5,7 L46.5,7 Z",
    id: "Path-4",
    fill: "url(#linearGradient-2)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.281036, 25.078480)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.281036, 25.078480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2688172,35.7671984 L53.2688172,49.168028 C53.2688172,58.0184611 59.7027879,65.5557409 68.443518,66.9449143 L71.1588465,67.3764643 C79.5929427,68.716904 87.5167696,62.9663593 88.8572094,54.5322631 C88.9847884,53.729531 89.0488759,52.9179893 89.0488759,52.1051823 L89.0488759,39.1003459 C89.0488767,29.1592199 80.9900018,21.100345 71.0488759,21.100345 C70.8886349,21.100345 70.7284011,21.1024848 70.5682174,21.1067638 C68.3507163,21.1659994 66.6501653,21.2896726 65.4665645,21.4777835 C65.4665645,21.4777835 65.4665645,21.4777835 65.4665645,21.4777835 C58.4405917,22.5944288 53.268838,28.6530442 53.2688172,35.7671984 Z",
    id: "Path-7",
    fill: "#EE1952",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/basket",
    transform: "translate(61.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-Gray",
    mask: "url(#mask-4)",
    fill: "#EE1952"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(55.795455, 78.076923)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EE1952",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE1952",
    mask: "url(#mask-6)",
    x: -7.79545455,
    y: -2.04487179,
    width: 18.9318182,
    height: 17.3814103
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 65.8181818,
    y: 80.3076923,
    width: 23.3863636,
    height: 2.23076923,
    rx: 1.11538462
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 66.9318182,
    y: 84.7692308,
    width: 13.3636364,
    height: 2.23076923,
    rx: 1.11538462
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(52.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 188.925764,
    height: 121.932203,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(130.794760, 27.966102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.08,
    x: 0,
    y: 0,
    width: 45.8340611,
    height: 20.1355932,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 6.71186441,
    width: 21.8257434,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 11.1864407,
    width: 15.2780204,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.456436, 4.971751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41558291,7.45054845 C7.35705981,6.06134224 7.82779827,4.88888761 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,4.89714141 0.491184098,6.08160989 1.47355229,7.48659001 L1.47355862,7.48658559 C2.42297447,8.84443736 4.29338443,9.17554009 5.6512362,8.22612424 C5.95119698,8.01639037 6.21024572,7.75353592 6.41558291,7.45054845 Z",
    id: "Oval",
    fill: "#140D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70666699,9.63266645 C6.78742117,7.25379738 7.82779827,5.35397009 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,5.35589635 1.06994875,7.25894972 3.20984624,9.64234469 L3.20981543,9.64237235 C3.57879811,10.0533413 4.21107384,10.0873779 4.6220428,9.71839525 C4.65194788,9.69154539 4.6802072,9.6629172 4.70666699,9.63266645 Z",
    id: "Oval",
    fill: "#4861FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 3.91389913,
    cy: 4.02126952,
    rx: 1.56555965,
    ry: 1.60850781
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 24.610169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.08,
    x: 0,
    y: 0,
    width: 45.8340611,
    height: 20.1355932,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 6.71186441,
    width: 21.8257434,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 11.1864407,
    width: 15.2780204,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.456436, 4.971751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41558291,7.45054845 C7.35705981,6.06134224 7.82779827,4.88888761 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,4.89714141 0.491184098,6.08160989 1.47355229,7.48659001 L1.47355862,7.48658559 C2.42297447,8.84443736 4.29338443,9.17554009 5.6512362,8.22612424 C5.95119698,8.01639037 6.21024572,7.75353592 6.41558291,7.45054845 Z",
    id: "Oval",
    fill: "#140D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70666699,9.63266645 C6.78742117,7.25379738 7.82779827,5.35397009 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,5.35589635 1.06994875,7.25894972 3.20984624,9.64234469 L3.20981543,9.64237235 C3.57879811,10.0533413 4.21107384,10.0873779 4.6220428,9.71839525 C4.65194788,9.69154539 4.6802072,9.6629172 4.70666699,9.63266645 Z",
    id: "Oval",
    fill: "#4861FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 3.91389913,
    cy: 4.02126952,
    rx: 1.56555965,
    ry: 1.60850781
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 49.220339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.08,
    x: 0,
    y: 0,
    width: 45.8340611,
    height: 20.1355932,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 6.71186441,
    width: 21.8257434,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.56,
    x: 17.4605947,
    y: 11.1864407,
    width: 15.2780204,
    height: 2.23728814,
    rx: 1.11864407
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.456436, 4.971751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41558291,7.45054845 C7.35705981,6.06134224 7.82779827,4.88888761 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,4.89714141 0.491184098,6.08160989 1.47355229,7.48659001 L1.47355862,7.48658559 C2.42297447,8.84443736 4.29338443,9.17554009 5.6512362,8.22612424 C5.95119698,8.01639037 6.21024572,7.75353592 6.41558291,7.45054845 Z",
    id: "Oval",
    fill: "#140D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70666699,9.63266645 C6.78742117,7.25379738 7.82779827,5.35397009 7.82779827,3.93318457 C7.82779827,1.56179813 6.07548594,0 3.91389913,0 C1.75231233,0 0,1.56179813 0,3.93318457 C0,5.35589635 1.06994875,7.25894972 3.20984624,9.64234469 L3.20981543,9.64237235 C3.57879811,10.0533413 4.21107384,10.0873779 4.6220428,9.71839525 C4.65194788,9.69154539 4.6802072,9.6629172 4.70666699,9.63266645 Z",
    id: "Oval",
    fill: "#4861FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 3.91389913,
    cy: 4.02126952,
    rx: 1.56555965,
    ry: 1.60850781
  })))), /*#__PURE__*/React.createElement("line", {
    x1: 0.555644557,
    y1: 17.3389831,
    x2: 187.80786,
    y2: 17.3389831,
    id: "Line",
    stroke: "#C5CDFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9173559,6.71186441 L10.3053059,132.246825 C9.51068237,133.700696 10.0451076,135.52346 11.4989781,136.318084 C11.9929217,136.588052 12.5528555,136.713605 13.1147808,136.680392 L260,122.087957 L260,122.087957 L88.9173559,122.087957 C83.3945084,122.087957 78.9173559,117.610805 78.9173559,112.087957 L78.9173559,6.71186441 L78.9173559,6.71186441 Z",
    id: "Path-4",
    fill: "url(#linearGradient-7)",
    opacity: 0.3,
    transform: "translate(133.853712, 71.855932) scale(-1, 1) translate(-133.853712, -71.855932) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97745299,50.7842686 L8.30224235,59.7333718 C7.99011772,63.8702075 8.8027069,68.0144457 10.6539345,71.7270981 L16.1815586,82.8127947 C16.7544015,83.9616361 17.2300558,85.1564202 17.6035377,86.3846289 L19.7306241,93.3796281 C21.3736069,98.7826353 25.9704793,102.764006 31.5527043,103.618783 L81.6309747,111.287004 C84.1277877,111.669328 86.6705277,111.63775 89.1570763,111.193539 L101.147491,109.051506 C110.471462,107.38582 117.567235,99.7501076 118.545882,90.329217 L120.166341,74.729964 C120.539291,71.139788 120.062029,67.5122331 118.773156,64.1406961 L113.564881,50.5164713 C111.27936,44.5378203 106.605882,39.781963 100.668075,37.3923334 L85.182737,31.1603649 C81.7931814,29.7962615 78.1274105,29.2593169 74.4890247,29.5940011 L25.3786354,34.1115189 C16.5750998,34.9213298 9.6425943,41.9686222 8.97745299,50.7842686 Z",
    id: "Path-5",
    fill: "#4861FF",
    opacity: 0.315994234
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6550218,52.5762712 L70.906867,52.5762712 C74.8268718,52.5762712 78.0046636,55.754063 78.0046636,59.6740678 C78.0046636,63.5940726 74.8268718,66.7718644 70.906867,66.7718644 L56.448598,66.7718644 C52.028167,66.7718644 48.4446997,70.3553317 48.4446997,74.7757627 C48.4446997,79.1961937 52.028167,82.779661 56.448598,82.779661 L89.4323144,82.779661 L89.4323144,82.779661",
    id: "Path-3",
    stroke: "#4861FF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/location",
    transform: "translate(91.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)",
    fill: "#4861FF",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.75,
    height: 17
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(4.146060, 3.880435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#140D40",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-11)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.224185, -0.958560)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.5625,
    height: 26.5625
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/location",
    transform: "translate(20.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-13)",
    fill: "#4861FF",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.75,
    height: 17
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(4.146060, 3.880435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#140D40",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-15)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.224185, -0.958560)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.5625,
    height: 26.5625
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(318.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5408698,0 L0.697908543,151.89482 C0.430477148,153.529949 1.53921503,155.072279 3.17434391,155.33971 C3.52825299,155.397593 3.88967328,155.391553 4.24145076,155.321878 L207,115.161972 L207,115.161972 L38.5408661,115.290124 C31.3611739,115.305472 25.5364497,109.489603 25.5309878,102.309904 C25.5309853,102.306607 25.5309841,102.303311 25.5408698,102.300014 L25.5408698,0 L25.5408698,0 Z",
    id: "Path-4",
    fill: "url(#linearGradient-16)",
    opacity: 0.3,
    transform: "translate(103.500000, 78.080986) scale(1, -1) translate(-103.500000, -78.080986) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 25.5208333,
    y: 40.9507042,
    width: 189.479167,
    height: 122.049296,
    rx: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.8690785,
    y1: 116.53169,
    x2: 87.6809689,
    y2: 116.53169,
    id: "Line-2",
    stroke: "#4861FF",
    strokeWidth: 5,
    opacity: 0.16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.8690785,
    y1: 126.609155,
    x2: 87.6809689,
    y2: 126.609155,
    id: "Line-2",
    stroke: "#4861FF",
    strokeWidth: 5,
    opacity: 0.16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.8690785,
    y1: 136.68662,
    x2: 87.6809689,
    y2: 136.68662,
    id: "Line-2",
    stroke: "#4861FF",
    strokeWidth: 5,
    opacity: 0.16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4861FF",
    opacity: 0.16,
    x: 120.364583,
    y: 71.1830986,
    width: 79,
    height: 78.3802817,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(138.520833, 82.380282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-18)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(13.040625, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-20)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(26.081250, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-22)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(39.121875, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-24)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 136.836293,
    y1: 95.2570423,
    x2: 183.674124,
    y2: 95.2570423,
    id: "Line-3",
    stroke: "#4861FF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(138.520833, 103.654930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-26)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(13.040625, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-28)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(26.081250, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-29"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-30)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(39.121875, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-31"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-32)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 136.836293,
    y1: 117.651408,
    x2: 183.674124,
    y2: 117.651408,
    id: "Line-3",
    stroke: "#4861FF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(138.520833, 122.690141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-33"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-34)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(13.040625, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-35"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-36)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(26.081250, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-37"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-38)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(39.121875, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4861FF",
    fillRule: "nonzero",
    xlinkHref: "#path-39"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4861FF",
    mask: "url(#mask-40)",
    x: -5.43359375,
    y: -1.00774648,
    width: 16.3007812,
    height: 13.1007042
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 136.836293,
    y1: 136.68662,
    x2: 183.674124,
    y2: 136.68662,
    id: "Line-3",
    stroke: "#4861FF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.6354167,
    y1: 56.0669014,
    x2: 215,
    y2: 56.0669014,
    id: "Line",
    stroke: "#C5CDFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "products",
    transform: "translate(83.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#140D40",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 13.0553097,
    width: 89.1551724,
    height: 117.69469,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 12.8053097,
    width: 89.6551724,
    height: 118.19469,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.689655, 36.336283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.090708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EE1952",
    fillRule: "nonzero",
    xlinkHref: "#path-41"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE1952",
    mask: "url(#mask-42)",
    x: -7.699553,
    y: -2.09070796,
    width: 18.6989144,
    height: 17.7710177
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.08,
    x: 14.2991699,
    y: 0,
    width: 45.0973819,
    height: 16.7256637,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 5.22676991,
    width: 30.798212,
    height: 2.09070796,
    rx: 1.04535398
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 9.66371681,
    width: 17.5989783,
    height: 2.09070796,
    rx: 1.04535398
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.689655, 59.336283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.090708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EE1952",
    fillRule: "nonzero",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE1952",
    mask: "url(#mask-44)",
    x: -7.699553,
    y: -2.09070796,
    width: 18.6989144,
    height: 17.7710177
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.08,
    x: 14.2991699,
    y: 0,
    width: 45.0973819,
    height: 16.7256637,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 5.22676991,
    width: 30.798212,
    height: 2.09070796,
    rx: 1.04535398
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 9.66371681,
    width: 17.5989783,
    height: 2.09070796,
    rx: 1.04535398
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.689655, 82.336283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.090708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EE1952",
    fillRule: "nonzero",
    xlinkHref: "#path-45"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE1952",
    mask: "url(#mask-46)",
    x: -7.699553,
    y: -2.09070796,
    width: 18.6989144,
    height: 17.7710177
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.08,
    x: 14.2991699,
    y: 0,
    width: 45.0973819,
    height: 16.7256637,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 5.22676991,
    width: 30.798212,
    height: 2.09070796,
    rx: 1.04535398
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 9.66371681,
    width: 17.5989783,
    height: 2.09070796,
    rx: 1.04535398
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.689655, 105.336283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.090708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EE1952",
    fillRule: "nonzero",
    xlinkHref: "#path-47"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE1952",
    mask: "url(#mask-48)",
    x: -7.699553,
    y: -2.09070796,
    width: 18.6989144,
    height: 17.7710177
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.08,
    x: 14.2991699,
    y: 0,
    width: 45.0973819,
    height: 16.7256637,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 5.22676991,
    width: 30.798212,
    height: 2.09070796,
    rx: 1.04535398
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1952",
    opacity: 0.557399554,
    x: 20.7988506,
    y: 9.66371681,
    width: 17.5989783,
    height: 2.09070796,
    rx: 1.04535398
  })), /*#__PURE__*/React.createElement("line", {
    x1: -1.79750117e-13,
    y1: 26.7433628,
    x2: 89.1084945,
    y2: 26.7433628,
    id: "Line",
    stroke: "#FCDAE3",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,0 L9.46283843,119.446001 C8.86472381,120.99113 9.632431,122.728573 11.1775604,123.326687 C11.6169524,123.496775 12.0902287,123.560977 12.5590539,123.514095 L137.7,111 L137.7,111 L65.7,111 C60.1771525,111 55.7,106.522847 55.7,101 L55.7,0 L55.7,0 Z",
    id: "Path-4",
    fill: "url(#linearGradient-49)",
    opacity: 0.4,
    transform: "translate(72.700000, 62.000000) scale(-1, -1) translate(-72.700000, -62.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(390.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-51",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/Naveo-Pink",
    mask: "url(#mask-51)",
    fill: "#EE1952"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -1.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 88,
    height: 88
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/location",
    transform: "translate(525.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/seq/11",
    mask: "url(#mask-53)",
    fill: "#5363CE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(5.853261, 5.478261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-55",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#140D40",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-55)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.728261, -1.353261)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/location",
    transform: "translate(285.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-57",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-56"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/seq/11",
    mask: "url(#mask-57)",
    fill: "#5363CE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(5.853261, 5.478261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-59",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-58"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#140D40",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-59)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.728261, -1.353261)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/location",
    transform: "translate(265.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-61",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/seq/11",
    mask: "url(#mask-61)",
    fill: "#5363CE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(5.853261, 5.478261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-62"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#140D40",
    xlinkHref: "#path-62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-63)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.728261, -1.353261)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(293.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-65",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-64"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/seq/11",
    mask: "url(#mask-65)",
    fill: "#5363CE"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 65,
    height: 65
  })))), /*#__PURE__*/React.createElement("g", {
    id: "storefront-outline-(1)",
    transform: "translate(376.000000, 249.000000)",
    fill: "#5363CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12533144,0 C3.54448021,0 2.99064533,0.186666667 2.47733495,0.56 C1.96402456,0.933333333 1.66684487,1.41333333 1.53176319,2 L0.140421888,7.88 C-0.197282311,9.33333333 0.0728810484,10.6 0.964420134,11.6933333 L1.34264884,12.0666667 L1.34264884,21.3333333 C1.34264884,22 1.6128122,22.6666667 2.16664708,23.1866667 C2.72048197,23.7066667 3.36887403,24 4.04428243,24 L22.9557176,24 C23.631126,24 24.3065344,23.7333333 24.8333529,23.1866667 C25.3601715,22.64 25.6573512,22 25.6573512,21.3333333 L25.6573512,12.0666667 L26.0355799,11.6933333 C26.927119,10.6 27.1972823,9.33333333 26.8595781,7.88 L25.4682368,2 C25.2926306,1.41333333 24.9819428,0.933333333 24.4821406,0.56 C23.9958465,0.186666667 23.469028,0 22.8746686,0 L4.12533144,0 M22.8071277,2.62666667 L24.2660099,8.50666667 C24.3875834,9.08 24.2660099,9.6 23.8877812,10.0666667 C23.550077,10.48 23.1313238,10.6666667 22.6180134,10.6666667 C22.1992602,10.6666667 21.8345396,10.5333333 21.5373599,10.2133333 C21.2401802,9.90666667 21.0780822,9.54666667 21.0375577,9.12 L20.2135595,2.66666667 L22.8071277,2.62666667 M4.12533144,2.66666667 L6.78644052,2.66666667 L5.96244228,9.12 C5.80034426,10.1733333 5.27352571,10.6666667 4.38198663,10.6666667 C3.82815174,10.6666667 3.40939853,10.48 3.11221884,10.0666667 C2.73399014,9.6 2.61241662,9.08 2.73399014,8.50666667 L4.12533144,2.66666667 M9.51509045,2.66666667 L12.1491832,2.66666667 L12.1491832,8.93333333 C12.1491832,9.4 12.0005934,9.8 11.6628892,10.16 C11.325185,10.5066667 10.9064318,10.6666667 10.3931214,10.6666667 C9.93384366,10.6666667 9.54210679,10.5066667 9.23141892,10.12 C8.92073106,9.73333333 8.77214121,9.33333333 8.77214121,8.88 L8.77214121,8.66666667 L9.51509045,2.66666667 M14.8508168,2.66666667 L17.4849095,2.66666667 L18.2278588,8.66666667 C18.3359241,9.22666667 18.2278588,9.69333333 17.8361219,10.0933333 C17.4849095,10.4933333 17.0256318,10.6666667 16.471797,10.6666667 C16.0530437,10.6666667 15.674815,10.5066667 15.3371108,10.16 C14.9994066,9.8 14.8508168,9.4 14.8508168,8.93333333 L14.8508168,2.66666667 M7.35378358,12.0666667 C8.20479816,12.8933333 9.25843526,13.3333333 10.528203,13.3333333 C11.6628892,13.3333333 12.6624936,12.8933333 13.5,12.0666667 C14.4320636,12.8933333 15.4586844,13.3333333 16.6068786,13.3333333 C17.7820892,13.3333333 18.7952018,12.8933333 19.6462164,12.0666667 C20.4026738,12.8933333 21.4157864,13.3333333 22.6855542,13.3333333 L22.9962421,13.3333333 L22.9962421,21.3333333 L4.04428243,21.3333333 L4.04428243,13.3333333 L4.38198663,13.3333333 C5.61122991,13.3333333 6.59732617,12.8933333 7.35378358,12.0666667 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "storefront-outline-(1)",
    opacity: 0.75,
    transform: "translate(304.000000, 156.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20859112,0 C2.75681794,0 2.32605748,0.138833333 1.92681607,0.4165 C1.52757466,0.694166667 1.2964349,1.05116667 1.19137137,1.4875 L0.109217024,5.86075 C-0.153441797,6.94166667 0.0566852599,7.88375 0.750104548,8.69691667 L1.04428243,8.97458333 L1.04428243,15.8666667 C1.04428243,16.3625 1.25440949,16.8583333 1.68516995,17.2450833 C2.11593042,17.6318333 2.62023536,17.85 3.145553,17.85 L17.854447,17.85 C18.3797646,17.85 18.9050823,17.6516667 19.31483,17.2450833 C19.7245778,16.8385 19.9557176,16.3625 19.9557176,15.8666667 L19.9557176,8.97458333 L20.2498955,8.69691667 C20.9433147,7.88375 21.1534418,6.94166667 20.890783,5.86075 L19.8086286,1.4875 C19.672046,1.05116667 19.4303999,0.694166667 19.0416649,0.4165 C18.6634362,0.138833333 18.2536884,0 17.7914089,0 L3.20859112,0 M17.7388771,1.95358333 L18.8735632,6.32683333 C18.9681204,6.75325 18.8735632,7.14 18.5793853,7.48708333 C18.3167265,7.7945 17.9910296,7.93333333 17.5917882,7.93333333 C17.2660912,7.93333333 16.9824197,7.83416667 16.75128,7.59616667 C16.5201402,7.36808333 16.394064,7.10033333 16.3625449,6.783 L15.7216574,1.98333333 L17.7388771,1.95358333 M3.20859112,1.98333333 L5.27834263,1.98333333 L4.63745511,6.783 C4.51137887,7.56641667 4.10163111,7.93333333 3.40821182,7.93333333 C2.97745135,7.93333333 2.65175442,7.7945 2.42061465,7.48708333 C2.12643677,7.14 2.0318796,6.75325 2.12643677,6.32683333 L3.20859112,1.98333333 M7.40062591,1.98333333 L9.44936471,1.98333333 L9.44936471,6.64416667 C9.44936471,6.99125 9.33379483,7.28875 9.07113601,7.5565 C8.80847719,7.81433333 8.48278025,7.93333333 8.08353884,7.93333333 C7.72632285,7.93333333 7.42163861,7.81433333 7.1799925,7.52675 C6.93834638,7.23916667 6.8227765,6.94166667 6.8227765,6.6045 L6.8227765,6.44583333 L7.40062591,1.98333333 M11.5506353,1.98333333 L13.5993741,1.98333333 L14.1772235,6.44583333 C14.2612743,6.86233333 14.1772235,7.20941667 13.8725393,7.50691667 C13.5993741,7.80441667 13.2421581,7.93333333 12.8113976,7.93333333 C12.4857007,7.93333333 12.1915228,7.81433333 11.928864,7.5565 C11.6662052,7.28875 11.5506353,6.99125 11.5506353,6.64416667 L11.5506353,1.98333333 M5.71960945,8.97458333 C6.38150968,9.58941667 7.2010052,9.91666667 8.18860237,9.91666667 C9.07113601,9.91666667 9.84860612,9.58941667 10.5,8.97458333 C11.2249383,9.58941667 12.0234212,9.91666667 12.9164612,9.91666667 C13.8305139,9.91666667 14.6184903,9.58941667 15.2803906,8.97458333 C15.8687463,9.58941667 16.6567228,9.91666667 17.6443199,9.91666667 L17.8859661,9.91666667 L17.8859661,15.8666667 L3.145553,15.8666667 L3.145553,9.91666667 L3.40821182,9.91666667 C4.36428993,9.91666667 5.13125369,9.58941667 5.71960945,8.97458333 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/packaging-default",
    opacity: 0.748246838,
    transform: "translate(397.500000, 132.658537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-67",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-66"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#000000",
    xlinkHref: "#path-66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-67)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color/primary-action",
    transform: "translate(204.000000, 193.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-69",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-68"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00ABC7",
    xlinkHref: "#path-68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/Naveo-Pink",
    mask: "url(#mask-69)",
    fill: "#EE1952"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -0.500000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 92,
    height: 92
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon/packaging-default",
    opacity: 0.75,
    transform: "translate(210.432432, 199.013514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-71",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-70"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#000000",
    xlinkHref: "#path-70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-White",
    mask: "url(#mask-71)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20.2162162,
    height: 20.2162162
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImg);
export default __webpack_public_path__ + "static/media/dashboard-img.1158fe504de5a6ca673cb51b7bdd15a7.svg";
export { ForwardRef as ReactComponent };